//gsap.registerPlugin(toggleClass)
//import { gsap } from "gsap";
//import { ScrollTrigger } from "gsap/all";

//gsap.registerPlugin(ScrollTrigger);

const menuAnim = {
  init() {
    /* Animation of the menu */

    let menuHomepageToggle = document.querySelector(".toggle");
    let menuHomepage = document.querySelector("#menuContainer");
    let menuHomepageMobile = document.querySelector(".menu-homepage-mobile");
    let menuHomepageToggleMobile = document.querySelector(
      ".toggle-wrapper-mobile .toggle"
    );

    //HOMEPAGE MENU
    if (menuHomepage) {
      gsap.to("#menuContainer", {
        //height: 0,
        //display: "none",
        opacity: 0,
        duration: 0,
      });
      gsap.to(".header-content", {
        backgroundColor: "transparent",
      });
      gsap.to("#menu-homepage", {
        translateY: "-100%",
      });

      var tlmenuHomepage = gsap.timeline({
        paused: true,
      });

      tlmenuHomepage
        .to(
          "#menuContainer",
          {
            opacity: 1,
          },
          0
        )

        .to(
          ".header-content",
          {
            background: "#0b0b0b",
          },
          0
        )
        .to("#menu-homepage", {
          translateY: "0%",
        })
 

      menuHomepageToggle.addEventListener("change", () => {
        menuHomepageToggle.classList.toggle("toggle-open");
        menuHomepage.classList.toggle("menu-homepage-open");

        if (
          menuHomepageToggle &&
          menuHomepageToggle.classList.contains("toggle-open") === false
        ) {
          tlmenuHomepage.timeScale(2).reverse();
        } else {
          tlmenuHomepage.timeScale(1).play();
        }
      });

      let menuItems = document.querySelectorAll(".menu-item-has-children");

      menuItems.forEach((item) => {
        let submenu = item.querySelector(".menu-homepage .sub-menu");

        var tlSubmenuHover = gsap.timeline({
          paused: true,
        });

        tlSubmenuHover
        .to(".header-content", {
          background: "white",
          
        },0)
        .to('#primaryMenu ul li a', {
          color:'#0b0b0b'
        })
        .to(".custom-logo-link img", {
          opacity: 0,
          duration: 0
        }, 0);

        item.addEventListener("mouseenter", () => {
          tlSubmenuHover.timeScale(2).play();
        });

        item.addEventListener("mouseleave", () => {
          tlSubmenuHover.timeScale(3).reverse();
        })
        
      });
    }

    // MOBILE

    if (menuHomepageMobile) {
      /* gsap.to(".menu-homepage-mobile .sub-menu", {
        //height: 0,
        display: "none",
        opacity: 0,
        duration: 0,
        
      }) */

      var tlmenuHomepageMobile = gsap.timeline({
        paused: true,
      });

      tlmenuHomepageMobile

        .to(".toggle-wrapper-mobile  svg", {
          stroke: "#0b0b0b",
        })
        .to(
          ".menu-homepage-mobile, .menu-homepage-mobile .top-bar",
          {
            minHeight: "100vh",
            display: "block",
          },
          0
        )
        .to(
          ".menu-homepage-mobile .custom-logo-link, .menu-homepage-mobile .menu",
          {
            y: 0,
            opacity: 1,
          },
          0
        );

      menuHomepageToggleMobile.addEventListener("change", () => {
        menuHomepageToggleMobile.classList.toggle("toggle-open");
        menuHomepageMobile.classList.toggle("menu-homepage-open");

        if (
          menuHomepageToggleMobile &&
          menuHomepageToggleMobile.classList.contains("toggle-open") === false
        ) {
          tlmenuHomepageMobile.timeScale(2).reverse();
        } else {
          tlmenuHomepageMobile.timeScale(1).play();
        }
      });

      let menuItems = document.querySelectorAll(
        ".menu-homepage-mobile .menu-item-has-children"
      );

      menuItems.forEach((item) => {
        let submenu = item.querySelector(".menu-homepage-mobile .sub-menu");
        let isOpen = false;

        item.addEventListener("touchstart", (event) => {
          event.stopPropagation(); // Prevents the event from bubbling up

          isOpen = !isOpen;

          if (isOpen) {
            gsap.to(submenu, {
              display: "block",
              opacity: 1,
              ease: "power2.inOut",
            });
          } else {
            gsap.to(submenu, {
              display: "none",
              opacity: 0,
              ease: "power2.inOut",
            });
          }
        });
      });

      // Add event listener to links
      let menuLinks = document.querySelectorAll(
        ".menu-homepage-mobile .menu-item a"
      );

      menuLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
          if (!link.closest(".menu-item-has-children")) {
            tlmenuHomepageMobile.timeScale(2).reverse();
            document
              .querySelector(".toggle-wrapper-mobile .toggle input")
              .click();

            goTo();
          }
        });
      });

      function goTo() {
        st.disable(false);

        gsap.to(window, {
          scrollTo: { y: "#equipe", autoKill: false },
          duration: 1,
          onComplete: () => st.enable(),
        });
      }
    }
  },
};

export default menuAnim;
